import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import {
  listPermissions,
  togglePermission,
  upsertPermission,
} from "../services/permissionService";
import { usePermissionStore } from "../stores/permissionStore";
import type {
  TogglePermissionRequest,
  UpsertPermissionRequest,
} from "../types/permission.types";

export const usePermissionList = () =>
  useQuery({
    queryKey: ["permissions"],
    queryFn: listPermissions,
    staleTime: 5_000,
  });

export const useUpsertPermission = () => {
  const qc = useQueryClient();
  const closeDialog = usePermissionStore((s) => s.closeDialog);

  return useMutation({
    mutationFn: (req: UpsertPermissionRequest) => upsertPermission(req),
    onSuccess: () => {
      toast.success("권한이 저장되었습니다.");
      qc.invalidateQueries({ queryKey: ["permissions"] });
      closeDialog();
    },
    onError: (err: Error) => {
      toast.error(`저장 실패: ${err.message}`);
    },
  });
};

export const useTogglePermission = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (req: TogglePermissionRequest) => togglePermission(req),
    onSuccess: (_data, variables) => {
      toast.success(
        variables.isActive
          ? "권한이 활성화되었습니다."
          : "권한이 비활성화되었습니다.",
      );
      qc.invalidateQueries({ queryKey: ["permissions"] });
    },
    onError: (err: Error) => {
      toast.error(`처리 실패: ${err.message}`);
    },
  });
};
